"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var useStyles = core_1.makeStyles({
    chip: {
        maxWidth: '100%',
    },
});
exports.Checkbox = function (props) {
    var column = props.column, handleChangeVisibility = props.handleChangeVisibility, isVisible = props.isVisible;
    var groupCode = column.groupCode, id = column.id, Header = column.Header, blockHide = column.blockHide, shortHeader = column.shortHeader;
    var _a = react_1.useState(isVisible), isChecked = _a[0], setIsChecked = _a[1];
    var variant = groupCode ? 'outlined' : 'default';
    var title = Header;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Tooltip, { title: title }, blockHide ? (react_1.default.createElement(core_1.Chip, { key: id, label: Header, variant: variant, className: classes.chip })) : (react_1.default.createElement(core_1.Chip, { key: id, label: shortHeader, variant: variant, className: classes.chip, icon: isChecked ? react_1.default.createElement(icons_1.CheckBoxOutlined, null) : react_1.default.createElement(icons_1.CheckBoxOutlineBlank, null), clickable: true, onClick: function () {
            handleChangeVisibility(column.columnCode);
            setIsChecked(function (isChecked) { return !isChecked; });
        } }))));
};
